import _ from 'lodash';
import React, { useCallback, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@tencent/spaui';
import { FormView, hooks, message } from '@tencent/ptp-fe-common';
import ApplyAppId from 'pages/manage/application/components/form/ApplyAppId';
import api from 'pages/manage/application/api';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { applyAdd, applyEdit } from 'pages/manage/application/services';
import { getCustomExtraKeyList, showNoticeDialog } from 'pages/manage/application/util';
import { Category, TRANS_UPLOAD_NAME_LIST, USE_PTP_FE_COMMON } from 'pages/manage/application/constants';
import Util from 'utils/index';
// import { fetchAppTypeOptions, getCsIndustryTree } from 'store/manager';
import { report } from 'store/report';
const IMAGE_UPLOADER_EXTRA = '仅支持上传图片文件，图片大小不超过1MB';
interface GroupProps {
  type?: string;
  id?: any;
  extraKeyList?: [];
  appTypeOptions?: [];
  csIndustryMap?: [];
  csIndustryData?: [];
}

const PicExtra = (props: { text: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal }) => {
  return (
    <div>
      <span>{props.text} </span>
      <a
        target="_blank"
        href="https://docs.qq.com/sheet/DWVNPeFd2ZVVVeE1s"
        style={{ color: '#0061e7', fontWeight: 'bolder' }}
        rel="noreferrer"
      >
        查看设计规范
      </a>
    </div>
  );
};

// 应用管理视图
const appManageGroups = (payloads: GroupProps, customFunctions: { checkUpload: any }, formData: any) => {
  const { appTypeOptions = [], csIndustryData } = payloads;
  const { checkUpload } = customFunctions;
  const { category } = formData || {};

  const extraKeyList = getCustomExtraKeyList(formData?.category);
  if ([Category.contentService, Category.dataService, Category.daiyunying].includes(category)) {
    return [
      {
        controls: [
          {
            name: 'category',
            type: 'select',
            label: '应用类型',
            config: {
              data: appTypeOptions,
              placeholder: '请选择应用类型',
            },
            rules: [{ required: true, message: '请选择应用类型' }],
          },
          {
            name: 'app_name',
            type: 'input',
            label: '应用名称',
            config: {
              placeholder: '请输入应用名称',
            },
            rules: [{ message: '请输入应用名称', required: true }],
          },
          {
            name: 'app_icon',
            type: 'file-uploader',
            label: '应用图标',
            extra: <PicExtra text={IMAGE_UPLOADER_EXTRA} />,
            config: {
              url: api.fileUpload,
              type: 'media',
              accept: 'image/*',
              multiple: false,
              count: 1,
              check: checkUpload,
              onFormatResponse: (data: any) => {
                const { file_url: url = '', file_name: fileName = '' } =
                  (Array.isArray(data) ? _.head(data) : data) || {};
                return { url, origin_name: fileName };
              },
            },
            rules: [{ message: '请上传应用图标', required: true }],
          },
          {
            name: 'version',
            type: 'input',
            label: '版本号',
            config: {
              placeholder: '请输入版本号',
            },
            rules: [
              {
                // pattern: /^[\d\s]*$/i,
                // message: '只允许输入数字',
                message: '请输入版本号',
                required: true,
              },
            ],
          },
          {
            name: 'app_desc',
            type: 'textarea',
            label: '应用描述',
            config: {
              placeholder: '请输入应用描述，200个字符以内',
              maxLength: 200, // 最大长度
              feedback: true, // 输入字数回显
              rows: 3, // 行数
            },
            rules: [{ required: true, message: '请输入应用描述' }],
          },
          {
            name: 'provider',
            type: 'input',
            label: '应用提供方',
            config: {
              placeholder: '请输入应用提供方',
            },
            rules: [{ required: true, message: '请输入应用提供方' }],
          },
          {
            name: 'app_image_list',
            type: 'file-uploader',
            label: '应用截图',
            extra: <PicExtra text={'仅支持上传JPG/PNG/MP4文件，图片不超过1MB, 视频不超过10MB'} />,
            config: {
              url: api.publicFileUpload,
              type: 'media',
              name: 'file',
              data: {
                fileVisibility: 'ALL_VISIBLE',
                type: 1,
              },
              accept: 'image/jpeg,image/jpg,image/png,.mp4',
              multiple: true,
              check: checkUpload,
              onFormatResponse: (data: any) => {
                const { full_path: url = '', name: fileName = '' } = (Array.isArray(data) ? _.head(data) : data) || {};
                return { url, origin_name: fileName };
              },
            },
            rules: [{ message: '请上传应用截图', required: true }],
          },
          {
            name: 'industry_id',
            type: 'select-tree',
            label: '所属行业',
            config: {
              data: csIndustryData,
              placeholder: '请选择所属行业',
            },
            rules: [{ required: true, message: '请选择所属行业' }],
          },
          ..._.map(extraKeyList, ({ name, label }: any) => {
            const params = {
              name,
              label,
            };
            const textForm = {
              type: 'textarea',
              ...params,
              config: {
                placeholder: `请输入${label}，400个字符以内`,
                maxLength: 400, // 最大长度
                feedback: true, // 输入字数回显
                rows: 5, // 行数
              },
              rules: [{ message: `请输入${label}`, required: false }],
            };
            return textForm;
          }),
        ],
      },
    ];
  }

  return [
    {
      controls: [
        {
          name: 'category',
          type: 'select',
          label: '应用类型',
          config: {
            data: appTypeOptions,
            placeholder: '请选择应用类型',
          },
          rules: [{ required: true, message: '请选择应用类型' }],
        },
        {
          name: 'client_id',
          label: '应用ID',
          type: 'custom',
          content: ApplyAppId,
          config: {
            placeholder: '请输入应用ID',
          },
          rules: [
            {
              pattern: /^[\d\s]*$/i,
              message: '只允许输入数字',
              required: true,
            },
          ],
        },
        {
          name: 'app_name',
          type: 'input',
          label: '应用名称',
          config: {
            placeholder: '请输入应用名称',
          },
          rules: [{ message: '请输入应用名称', required: true }],
        },
        {
          name: 'app_icon',
          type: 'file-uploader',
          label: '应用图标',
          extra: <PicExtra text={IMAGE_UPLOADER_EXTRA} />,
          config: {
            url: api.fileUpload,
            type: 'media',
            accept: 'image/*',
            multiple: false,
            count: 1,
            check: checkUpload,
            onFormatResponse: (data: any) => {
              const { file_url: url = '', file_name: fileName = '' } =
                (Array.isArray(data) ? _.head(data) : data) || {};
              return { url, origin_name: fileName };
            },
          },
          rules: [{ message: '请上传应用图标', required: true }],
        },
        {
          display: [
            {
              name: 'category',
              exp: '===',
              value: Category.privateDomain, // 私域运营时才展示
            },
          ],
          name: 'app_token',
          type: 'input',
          label: 'app_token',
          config: {
            placeholder: '请输入app_token',
          },
          rules: [{ message: '请输入app_token', required: true }],
        },
        {
          name: 'version',
          type: 'input',
          label: '版本号',
          config: {
            placeholder: '请输入版本号',
          },
          rules: [
            {
              // pattern: /^[\d\s]*$/i,
              // message: '只允许输入数字',
              message: '请输入版本号',
              required: true,
            },
          ],
        },
        {
          name: 'app_desc',
          type: 'textarea',
          label: '应用描述',
          config: {
            placeholder: '请输入应用描述，200个字符以内',
            maxLength: 200, // 最大长度
            feedback: true, // 输入字数回显
            rows: 3, // 行数
          },
          rules: [{ required: true, message: '请输入应用描述' }],
        },
        {
          name: 'website_url',
          type: 'input',
          label: '应用网址',
          config: {
            placeholder: '请输入应用网址',
          },
          rules: [{ required: true, message: '请输入应用网址' }],
        },
        {
          name: 'provider',
          type: 'input',
          label: '应用提供方',
          config: {
            placeholder: '请输入应用提供方',
          },
          rules: [{ required: true, message: '请输入应用提供方' }],
        },
        {
          name: 'app_image_list',
          type: 'file-uploader',
          label: '应用截图',
          extra: <PicExtra text={'仅支持上传JPG/PNG/MP4文件，图片不超过1MB, 视频不超过10MB'} />,
          config: {
            url: api.publicFileUpload,
            type: 'media',
            name: 'file',
            data: {
              fileVisibility: 'ALL_VISIBLE',
              type: 1,
            },
            accept: 'image/jpeg,image/jpg,image/png,.mp4',
            multiple: true,
            check: checkUpload,
            onFormatResponse: (data: any) => {
              const { full_path: url = '', name: fileName = '' } = (Array.isArray(data) ? _.head(data) : data) || {};
              return { url, origin_name: fileName };
            },
          },
          rules: [{ message: '请上传应用截图', required: true }],
        },
        {
          name: 'industry_id',
          type: 'select-tree',
          label: '所属行业',
          config: {
            data: csIndustryData,
            placeholder: '请选择所属行业',
          },
          rules: [{ required: true, message: '请选择所属行业' }],
        },
        {
          name: 'redirect_uri',
          type: 'input',
          label: '回调URL',
          config: {
            placeholder: '请输入回调URL',
          },
          rules: [{ required: true, message: '请输入回调URL' }],
        },
        ..._.map(extraKeyList, ({ name, label }: any) => {
          const params = {
            name,
            label,
          };
          const textForm = {
            type: 'textarea',
            ...params,
            config: {
              placeholder: `请输入${label}，400个字符以内`,
              maxLength: 400, // 最大长度
              feedback: true, // 输入字数回显
              rows: 5, // 行数
            },
            rules: [{ message: `请输入${label}`, required: true }],
          };
          return textForm;

          // 链接格式tips: ^&*营销服务市场^&*(https://isv.e.qq.com)

          // const fileForm = {
          //   type: USE_PTP_FE_COMMON ? 'file-uploader' : 'custom',
          //   content: !USE_PTP_FE_COMMON && MultiUpload,
          //   ...params,
          //   extra: USE_PTP_FE_COMMON && '图片不超过1MB, 视频不超过10MB',
          //   config: {
          //     url: api.fileUpload,
          //     name: 'file',
          //     multiple: true,
          //     check: checkUpload,
          //     max: 10,
          //   },
          //   rules: [{ message: `请上传${label}`, required: true }],
          // };
          // if (USE_PTP_FE_COMMON) {
          //   _.assign(fileForm.config, {
          //     url: api.publicFileUpload,
          //     // accept: '.DOC,.DOCX,.PNG,.JPEG,.JPG,.GIF,.BMP,.PDF,.XLS,.XLSX,.PPT,.PPTX',
          //     data: {
          //       fileVisibility: 'ALL_VISIBLE',
          //       type: 1,
          //     },
          //     filter: (fileInfo: File) => {
          //       const max = 10;
          //       const { size } = fileInfo;
          //       if (size > max * 1024 * 1024) {
          //         message.error(`文件大小超过${max}M限制`);
          //         return false;
          //       }
          //       return true;
          //     },
          //     onFormatResponse: (data: any) => {
          //       const { full_path: url = '', name: fileName = '' } = (Array.isArray(data) ? _.head(data) : data) || {};
          //       return { url, origin_name: fileName };
          //     },
          //   });
          // }
          // return _.includes(TRANS_UPLOAD_NAME_LIST, label) ? fileForm : textForm;
        }),
      ],
    },
  ];
};

const options = ({ payloads, customFunctions, formData }: any) => {
  const { isCreate, id, clientId } = payloads;
  const extraKeyList = getCustomExtraKeyList(formData?.category);
  return {
    submitConfig: {
      action: isCreate ? applyAdd : applyEdit,
      $onRequest(params: any) {
        const retParams = {
          ...{ id: !isCreate && parseInt(id, 10) },
          ...params,
        };
        retParams.app_icon = _.head(params?.app_icon)?.url;
        const extra = _.map(_.keys(params), (key: string) => {
          const matchList = _.find(extraKeyList, ['name', key]) || {};
          if (!_.isEmpty(matchList)) {
            const { label = '' } = matchList;
            let value = params[key];
            if (_.includes(TRANS_UPLOAD_NAME_LIST, label)) {
              // 格式化合作案例数据
              if (!USE_PTP_FE_COMMON) {
                value = _.filter(value, ({ status = 'success' }) => status !== 'fail');
              }
              value = _.filter(value, ({ url = '' }) => !_.isEmpty(url));
              value = _.isEmpty(value)
                ? ''
                : JSON.stringify(_.map(value, ({ name = '', url = '' }) => ({ name, url })));
            }
            return { label, value };
          }
        });
        // 格式化应用截图数据
        retParams.app_image_list = _.map(params?.app_image_list, ({ name = '', url = '' }) => ({ name, url }));
        retParams.extra = _.filter(extra, (item: any) => !_.isEmpty(item));
        if (!retParams.client_id) {
          retParams.client_id = clientId;
        }
        return retParams;
      },
    },
    groups: appManageGroups(payloads, customFunctions, formData),
  };
};
const { useDialog } = hooks;
const ApplicationEdit: (props: any) => JSX.Element = (props: any) => {
  const history = useHistory();
  const { payloads = {}, customFunctions = {} } = props || {};
  const { formData, isCreate } = payloads;
  const { setIsEditing } = customFunctions;
  const { Dialog, setDialogOptions, hideDialog } = useDialog();
  const {
    manager: { appTypeOptions, csIndustryTree, areaList },
  } = useTypedSelector((state) => state);

  useEffect(() => {
    const text = isCreate ? '添加' : '编辑';
    report({ event: 'application_manage', payload: `${text}应用界面` });
  }, [isCreate]);

  // 行业树
  const csIndustryData = Util.formatCsIndustryTree(
    {
      data: csIndustryTree,
      isFilterItem: true,
    },
    true
  );
  const csIndustryMap = Util.getCsIndustryMap(csIndustryTree, true); // 开户行业树id映射：根据'industry_short_id'建立
  // 区域树
  const areaTreeData = Util.formatAreaTree(areaList, true);

  const dispatch = useAppDispatch();
  const checkUpload = useCallback((fileInfo: { size: any; type: any }, next: () => void) => {
    const { size, type } = fileInfo;
    if (type.includes('image') && size > 1024 * 1024) {
      message.error('图片最大不能超过1M!');
      return;
    }
    if ((type.includes('video') || type.includes('audio')) && size > 10 * 1024 * 1024) {
      message.error('视频最大不能超过10M!');
      return;
    }
    next();
  }, []);

  const formRef = useRef(null);

  // 点击确认按钮的回调
  const handleSuccess = () => {
    hideDialog();
    isCreate ? history.replace('/manage/application') : window.location.reload();
  };

  // 点击确认按钮的回调
  const handleCancel = () => {
    hideDialog();
    isCreate ? history.replace('/manage/application') : window.location.reload();
  };

  // 添加应用成功或失败弹窗
  const showAddDialog = (type: string, message?: string) => {
    const opText = isCreate ? '添加' : '更新';
    const title = type === 'success' ? `应用${opText}成功` : `${opText}失败`;
    const content = type === 'success' ? '我们将在 1-7 个工作日内联系您进行上架审核，请耐心等待' : message;
    showNoticeDialog(
      { type, title, content: isCreate && content },
      { setDialogOptions, hideDialog },
      type === 'success' ? handleSuccess : hideDialog,
      type === 'success' ? handleCancel : hideDialog
    );
  };

  useEffect(() => {
    if (isCreate) {
      // dispatch(fetchAppTypeOptions());
      // dispatch(getCsIndustryTree());
    }
  }, [dispatch, isCreate]);

  const onSubmit = useCallback(async () => {
    const { form } = formRef.current || {};
    try {
      await form.validate();
    } catch (error) {
      throw error;
    }
    try {
      await form.onSubmit();
      showAddDialog('success');
    } catch (error) {
      showAddDialog('fail', error.message || '');
      throw error;
    }
  }, [showAddDialog]);
  const formViewProps = (() => {
    if (!isCreate) {
      return { formData };
    }
  })();

  return (
    <div>
      <FormView
        className="app-edit"
        {...formViewProps}
        ref={formRef}
        options={options}
        payloads={{
          ...payloads,
          appTypeOptions,
          csIndustryMap,
          csIndustryData,
          areaTreeData,
        }}
        customFunctions={{
          checkUpload,
          ...customFunctions,
        }}
      />
      <div className="form-group-footer">
        <Button displayType="primary" onClick={() => onSubmit()}>
          确定
        </Button>
        <Button
          onClick={() => {
            isCreate ? history.goBack() : setIsEditing(false);
          }}
        >
          取消
        </Button>
      </div>
      {Dialog}
    </div>
  );
};
export default ApplicationEdit;
